import React from "react";
import { Form, Input, InputProps, InputRef } from "antd";

export default function VtPasswordInput(
  props: React.JSX.IntrinsicAttributes &
    InputProps &
    React.RefAttributes<InputRef>
) {
  return <Input.Password placeholder='Enter your password' {...props} />;
} 